import { render, staticRenderFns } from "./quizAppStorefront.vue?vue&type=template&id=83ce879e"
import script from "./quizAppStorefront.vue?vue&type=script&lang=js"
export * from "./quizAppStorefront.vue?vue&type=script&lang=js"
import style0 from "./quizAppStorefront.vue?vue&type=style&index=0&id=83ce879e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ce879e')) {
      api.createRecord('83ce879e', component.options)
    } else {
      api.reload('83ce879e', component.options)
    }
    module.hot.accept("./quizAppStorefront.vue?vue&type=template&id=83ce879e", function () {
      api.rerender('83ce879e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/quizAppStorefront.vue"
export default component.exports